import { render, staticRenderFns } from "./MaskImageCkyc.vue?vue&type=template&id=7ecbc74d&scoped=true&"
import script from "./MaskImageCkyc.vue?vue&type=script&lang=js&"
export * from "./MaskImageCkyc.vue?vue&type=script&lang=js&"
import style0 from "./MaskImageCkyc.vue?vue&type=style&index=0&id=7ecbc74d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecbc74d",
  null
  
)

export default component.exports